import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  baseStyle: {
    field: {
      height: '32px',
      fontSize: '13px',
      borderRadius: '2px',
    },
  },
  fonts: {
    body: 'Arial, sans-serif',
    heading: 'Arial, sans-serif',
  },
  colors: {
    brand: {
      blue: '#0057B8',
      bg: '#F5F6F8',
      labelBG: '#F1F1F1',
      subHeading: 'gray.800',
      content: 'gray.700',
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '4px',
        fontWeight: 500,
      },
    },
  },
  styles: {
    global: {
      body: {
        bg: '#fff',
        color: '#333',
      },
    },
  },
});

export default theme;
